import PropTypes from 'prop-types';
import { Icon } from '@evertrue/et-components';

/**
 * Renders the title, type badge, and mode subline for a cadence step.
 * Used consistently in the performance table, recipient drawer, and contact cadences modals.
 *
 * Layout:
 *   Title (user-defined step name)
 *   [icon  Type badge]
 *   Automated / Manual (ID N)
 */
const StepLabelBlock = ({ title, typeLabel, typeIcon, badgeColor, modeSubline, dimmed }) => (
  <div className="step-label-block">
    {title && <div className="step-label-block--title">{title}</div>}
    <span className="step-label-block--badge" style={{ background: dimmed ? '#9ca3af' : badgeColor }}>
      {typeIcon && <Icon icon={typeIcon} />}
      {typeLabel}
    </span>
    {modeSubline && <div className="step-label-block--mode">{modeSubline}</div>}
  </div>
);

StepLabelBlock.propTypes = {
  title: PropTypes.string,
  typeLabel: PropTypes.string.isRequired,
  typeIcon: PropTypes.string,
  badgeColor: PropTypes.string.isRequired,
  modeSubline: PropTypes.string,
  dimmed: PropTypes.bool,
};

export default StepLabelBlock;
